export default __webpack_public_path__ + "static/media/Wallet.5973197473d9a11375db54969e10e25f.webp";